import { getAppName, getNativeInfo, isInApp } from '@docs/common'
import { lowerCase } from 'lodash'
import { MEGA_DOMAINS } from './constant'

export const DOMAINS = {
  app: {
    qa: 'https://security-app-qa.eufylife.com',
    pr: 'https://security-app.eufylife.com',
  },
}
export const isDev = () => process.env.NODE_ENV === 'development'

/** 获取默认域名, 假如 */
export async function getDefaultDomain() {
  const subdomain = process.env.DEPLOY_ENV === 'pr' ? 'security-app' : 'security-app-qa'

  return `${subdomain}.eufylife.com`
}

/** 获取当前用户所在域名 */
export async function getDomain() {
  let domain
  try {
    domain = (await getNativeInfo()).domain
  } catch {
    // 没有 jsbridge 接口
  }

  return domain || (await getDefaultDomain())
}

export const getAppDomain = async () => {
  if (isDev()) return '/app'
  if (await isInApp()) {
    const appinfo = await getNativeInfo()
    const origin = appinfo?.domain || (isQa() ? DOMAINS.app.qa : DOMAINS.app.pr)
    return origin.indexOf('http') === 0 ? origin : `https://${origin}`
  } else {
    if (isQa()) return DOMAINS.app.qa
    return DOMAINS.app.pr
  }
}

export async function getLowCaseAppName() {
  const queryAppName = getQueryParam('app')
  if (queryAppName) {
    return lowerCase(queryAppName)
  }
  const appName = await getAppName()
  return lowerCase(appName)
}

export function getQueryParam(param: string): string | null {
  const url = window.location.href;
  const urlParams = new URLSearchParams(new URL(url).search);
  return urlParams.get(param);
}

export async function getWebAppName() {
  const queryAppName = getQueryParam('app')
  if (queryAppName) {
    return queryAppName
  }
  const appName = await getAppName() 
  return appName
}

/** 是否为服务端 */
export function isServerSide(): boolean {
  return typeof window === 'undefined'
}
export function getClientEnv(key: string): string | undefined {
  if (isServerSide()) {
    console.log('getClientEnv isServerSide', process.env[key])
    return process.env[key]
  }
  const envs = window.sessionStorage.getItem('ENVS')
  console.log('getClientEnv envs', envs)
  if (envs) {
    const parsed = JSON.parse(envs)
    console.log('getClientEnv parsed', parsed)
    return parsed[key]
  }else{
    return process.env[key]
  }
}
export function isQa() {
  return getClientEnv('REACT_APP_DEPLOY_ENV') === 'qa'
}

export const isEu =   (domain:string) => {
  if (domain) {
    return domain.includes("-eu-pr")
  }
  return false
}
export const isEuQa = (domain:string) => {
  if (domain) {
    return domain.includes("-eu-qa")
  }
  return false
}
export const isCN = () => {
  const domain = window.location.hostname
  if (domain) {
    return domain.includes("-cn-pr")
  }
  return false
}

const getDomainMega = async (host: string) => {
  const {domain} = await getNativeInfo()

  console.log(`更123141 isDev:${isDev()} isQa:${isQa()} isEu:${isEu(domain)} isCN:${isCN()}`)
  if (isDev()) return MEGA_DOMAINS[host].qa
  if (isEuQa(domain)) return MEGA_DOMAINS[host]['eu-qa']
  if (isQa()) return MEGA_DOMAINS[host].qa
  if (isEu(domain)) return MEGA_DOMAINS[host].eu
  if (isCN()) return MEGA_DOMAINS[host].cn
  return MEGA_DOMAINS[host].us
}

export const getPowerManageDomain = () =>  getDomainMega('powermanage')
export const getPddDomain = () => getDomainMega('pdd')
export const getPassportDomain = () => getDomainMega('passport')
export const getPushDomain = () => getDomainMega('push')
export const getHouseDomain = () => getDomainMega('house')